import { createClient } from 'contentful';
import config from '../../config/app';

export const FETCH_CONTENTFUL_REQUEST = 'fetchContentfulRequest';
export const FETCH_CONTENTFUL_SUCCESS = 'fetchContentfulSuccess';
export const FETCH_CONTENTFUL_ERROR = 'fetchContentfulError';

const LatestArticlesQuery = {
  content_type: 'article',
  limit: 10,
  order: '-fields.date'
};

function fetchRequest() {
  return {
    type: FETCH_CONTENTFUL_REQUEST
  };
}

function fetchSuccess(items) {
  return {
    type: FETCH_CONTENTFUL_SUCCESS,
    payload: { items }
  };
}

function fetchError(error) {
  return {
    type: FETCH_CONTENTFUL_ERROR,
    payload: error
  };
}

export function fetchContentfulResults() {
  return async (dispatch, getState) => {
    const state = getState();
    if (state.contentful.isFetching || state.contentful.items.length !== 0) {
      return;
    }

    try {
      dispatch(fetchRequest());

      const client = await createClient({
        space: config.CONTENTFUL_SPACE,
        accessToken: config.CONTENTFUL_TOKEN,
      });

      const payload = await client.getEntries(LatestArticlesQuery);

      dispatch(fetchSuccess(payload.items));
    } catch (error) {
      console.error(error);
      dispatch(fetchError(error));
    }
  };
}
